export const ACTIVATION_SELECT_ENABLE = 1
export const ACTIVATION_SELECT_DISABLE = 2
export const ACTIVATION_SELECT_ALL = 3

export const ACTIVATION_ENABLE_STRING = "啟用"
export const ACTIVATION_DISABLE_STRING = "停用"
export const ACTIVATION_ALL_STRING = "全部"

export const ACTIVATION_ENABLE = 1
export const ACTIVATION_DISABLE = 0


export const activation_Items = [
    { val: ACTIVATION_ENABLE, name: ACTIVATION_ENABLE_STRING },
    { val: ACTIVATION_DISABLE, name: ACTIVATION_DISABLE_STRING },
]

export const activation_only_disable = [
    { val: ACTIVATION_DISABLE, name: ACTIVATION_DISABLE_STRING },
]

export function get_activation_string(val){
    switch(val){
        case ACTIVATION_ENABLE:
            return ACTIVATION_ENABLE_STRING
        case ACTIVATION_DISABLE:
            return ACTIVATION_DISABLE_STRING
        default:
            return ""
    }
}

export function get_activation_color(val){
    switch(val){
        case ACTIVATION_ENABLE:
            return 'info'
        case ACTIVATION_DISABLE:
            return 'danger'
        default:
            return ""
    }
}

export const PHOTO_AUTH_SELF = 0
export const PHOTO_AUTH_AUTHORIZATION = 1

export const PHOTO_AUTH_SELF_STRING = "自攝"
export const PHOTO_AUTH_AUTHORIZATION_STRING = "授權"

export const photo_auth_arr = [
    { val: PHOTO_AUTH_SELF, name: PHOTO_AUTH_SELF_STRING },
    { val: PHOTO_AUTH_AUTHORIZATION, name: PHOTO_AUTH_AUTHORIZATION_STRING },
]

export function get_photo_auth_string(val){
    switch(val){
        case PHOTO_AUTH_SELF:
            return PHOTO_AUTH_SELF_STRING
        case PHOTO_AUTH_AUTHORIZATION:
            return PHOTO_AUTH_AUTHORIZATION_STRING
        default:
            return ""
    }
}

export const search_activation_attr = [
    { "val": ACTIVATION_SELECT_ALL, "name": ACTIVATION_ALL_STRING },
    { "val": ACTIVATION_SELECT_ENABLE, "name": ACTIVATION_ENABLE_STRING },
    { "val": ACTIVATION_SELECT_DISABLE, "name": ACTIVATION_DISABLE_STRING },
]
